module.exports = __webpack_public_path__ + "static/dna-feef95c054bd4662f9d8220fab375a67.jpg";